// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3231 ? "5dde9fb5" : chunkId) + "." + {"3060":"5598c05cf9374ff2","3231":"a86a2fc1722c23d0","3256":"b46683582a48e6d5","5494":"eec547f8942bff18","8763":"1f57a73a6bff6099","9182":"ba4fc4cb2f20ded3"}[chunkId] + ".js";
};